import { render, staticRenderFns } from "./mobileRapportConfig.vue?vue&type=template&id=462e0888&"
import script from "./mobileRapportConfig.vue?vue&type=script&lang=ts&"
export * from "./mobileRapportConfig.vue?vue&type=script&lang=ts&"
import style0 from "./mobileRapportConfig.vue?vue&type=style&index=0&id=462e0888&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports